var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.badgeClasses},[_vm._t("default"),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"jds-badge__dot",style:(_vm.dotStyles)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }